var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ApiService from './ApiService';
import UserService from './UserService';
import { ClinicReports, Create, DoctorReports, Index, PackageReports, PatientReports, Show, Update, Audit, UpdateConfig, MarkAsAfterWork, MarkAsInVisit, MarkAsCancelled, MarkAsConfirmed, MarkAsFinished, MarkAsLate, MarkAsPending, MarkAsUnReached, MarkAsWaiting, CurrentInVisitAppointment, AssignEmployees, Void, AddMedicalMachine, AssignClinic, AppendStep, Transition, TransitionStep, FulfillItem, Queue } from 'constants/actions';
import { ProductCategory, Product, Supplier, Stock, StockMovement, Account, AccountType, Transaction, Balance, FinancialPeriod, Document, Reports, Diagnose, FollowUp, MedicalRay, MedicalTest, Employee, MedicalMachine, Package, Appointments, MedicalCenter, Patient, Doctor, DoctorSchedule, ReceptionDesk, ClinicRoom, OrderEntity, ServiceOrder, PatientJourney } from 'constants/resources';
var PermissionService = /** @class */ (function (_super) {
    __extends(PermissionService, _super);
    function PermissionService() {
        var _this = _super.call(this) || this;
        _this.userService = UserService.getInstance();
        return _this;
    }
    PermissionService.prototype.hasPermissionToAdd = function (resource) {
        return this.userService.hasPermission(Create, resource);
    };
    PermissionService.prototype.hasPermissionToEdit = function (resource) {
        return this.userService.hasPermission(Update, resource);
    };
    PermissionService.prototype.hasPermissionToIndex = function (resource) {
        return this.userService.hasPermission(Index, resource);
    };
    PermissionService.prototype.hasPermissionToShow = function (resource) {
        return this.userService.hasPermission(Show, resource);
    };
    PermissionService.prototype.hasPermissionToViewDoctorSchedules = function () {
        return this.hasPermissionToIndex(DoctorSchedule) &&
            this.hasPermissionToShow(DoctorSchedule);
    };
    PermissionService.prototype.hasPermissionToViewReceptionDesks = function () {
        return this.hasPermissionToIndex(ReceptionDesk) &&
            this.hasPermissionToShow(ReceptionDesk);
    };
    PermissionService.prototype.hasPermissionToViewClinicRooms = function () {
        return this.hasPermissionToIndex(ClinicRoom) &&
            this.hasPermissionToShow(ClinicRoom);
    };
    PermissionService.prototype.hasPermissionToAssignReceptionDeskEmployees = function () {
        return this.userService.hasPermission(AssignEmployees, ReceptionDesk);
    };
    PermissionService.prototype.hasPermissionToViewOrderEntities = function () {
        return this.hasPermissionToIndex(OrderEntity) &&
            this.hasPermissionToShow(OrderEntity);
    };
    PermissionService.prototype.hasPermissionToLinkOrderEntityMachine = function () {
        return this.userService.hasPermission(AddMedicalMachine, OrderEntity);
    };
    PermissionService.prototype.hasPermissionToAssignOrderEntityClinic = function () {
        return this.userService.hasPermission(AssignClinic, OrderEntity);
    };
    PermissionService.prototype.hasPermissionToVoidServiceOrder = function () {
        return this.userService.hasPermission(Void, ServiceOrder);
    };
    PermissionService.prototype.hasPermissionToViewPatientJourneys = function () {
        return this.hasPermissionToIndex(PatientJourney) &&
            this.hasPermissionToShow(PatientJourney);
    };
    PermissionService.prototype.hasPermissionToAppendPatientJourneyStep = function () {
        return this.userService.hasPermission(AppendStep, PatientJourney);
    };
    PermissionService.prototype.hasPermissionToFulfillServiceOrderItem = function () {
        return this.userService.hasPermission(FulfillItem, ServiceOrder);
    };
    PermissionService.prototype.hasPermissionToTransitionPatientJourney = function () {
        return this.userService.hasPermission(Transition, PatientJourney);
    };
    PermissionService.prototype.hasPermissionToTransitionPatientJourneyStep = function () {
        return this.userService.hasPermission(TransitionStep, PatientJourney);
    };
    PermissionService.prototype.hasPermissionToViewPatientJourneyQueue = function () {
        return this.userService.hasPermission(Queue, PatientJourney);
    };
    /** OPD-only: permissions + medical-center config.patient_journeys_enabled */
    PermissionService.prototype.hasPatientJourneysFeatureEnabled = function (patientJourneysEnabled) {
        return this.hasPermissionToViewPatientJourneys() && patientJourneysEnabled === true;
    };
    PermissionService.prototype.hasPermissionForHomePage = function () {
        return this.hasPermissionToChangeAppointmentStatus() ||
            this.hasPermissionToAdd(Patient) ||
            this.userService.hasPermission(CurrentInVisitAppointment, Doctor);
    };
    PermissionService.prototype.hasAnyInventoryPermission = function () {
        return this.hasProductPermission() ||
            this.hasProductTypePermission() ||
            this.hasSupplierPermission() ||
            this.hasStockPermission() ||
            this.hasStockMovementPermission();
    };
    PermissionService.prototype.hasAnyFinanicePermission = function () {
        return this.hasAccountTypePermission() ||
            this.hasAccountPermission() ||
            this.hasTransactionPermission() ||
            this.hasBalancePermission() ||
            this.hasFinancialPeriodPermission() ||
            this.hasDocumentPermission();
    };
    PermissionService.prototype.hasAnyReportPermission = function () {
        return this.hasDoctorReportsPermission() ||
            this.hasPackageReportsPermission() ||
            this.hasPatientReportsPermission() ||
            this.hasClinicReportsPermission();
    };
    PermissionService.prototype.hasProductTypePermission = function () {
        return this.userService.hasPermission(Index, ProductCategory);
    };
    PermissionService.prototype.hasProductPermission = function () {
        return this.userService.hasPermission(Index, Product);
    };
    PermissionService.prototype.hasSupplierPermission = function () {
        return this.userService.hasPermission(Index, Supplier);
    };
    PermissionService.prototype.hasStockPermission = function () {
        return this.userService.hasPermission(Index, Stock);
    };
    PermissionService.prototype.hasPermissionToStockAudit = function () {
        return this.userService.hasPermission(Audit, Stock);
    };
    PermissionService.prototype.hasStockMovementPermission = function () {
        return this.userService.hasPermission(Index, StockMovement);
    };
    PermissionService.prototype.hasAccountTypePermission = function () {
        return this.userService.hasPermission(Index, AccountType);
    };
    PermissionService.prototype.hasAccountPermission = function () {
        return this.userService.hasPermission(Index, Account);
    };
    PermissionService.prototype.hasBalancePermission = function () {
        return this.userService.hasPermission(Index, Balance);
    };
    PermissionService.prototype.hasFinancialPeriodPermission = function () {
        return this.userService.hasPermission(Index, FinancialPeriod);
    };
    PermissionService.prototype.hasDocumentPermission = function () {
        return this.userService.hasPermission(Index, Document);
    };
    PermissionService.prototype.hasTransactionPermission = function () {
        return this.userService.hasPermission(Index, Transaction);
    };
    PermissionService.prototype.hasDoctorReportsPermission = function () {
        return this.userService.hasPermission(DoctorReports, Reports);
    };
    PermissionService.prototype.hasPatientReportsPermission = function () {
        return this.userService.hasPermission(PatientReports, Reports);
    };
    PermissionService.prototype.hasPackageReportsPermission = function () {
        return this.userService.hasPermission(PackageReports, Reports);
    };
    PermissionService.prototype.hasClinicReportsPermission = function () {
        return this.userService.hasPermission(ClinicReports, Reports);
    };
    PermissionService.prototype.hasPatientLogPermission = function () {
        return this.userService.hasPermission(Index, Diagnose) ||
            this.userService.hasPermission(Index, FollowUp) ||
            this.userService.hasPermission(Index, MedicalRay) ||
            this.userService.hasPermission(Index, MedicalTest);
    };
    PermissionService.prototype.hasOtherPermission = function () {
        return this.userService.hasPermission(Index, Employee) ||
            this.userService.hasPermission(Index, MedicalMachine) ||
            this.userService.hasPermission(Index, Package) ||
            this.hasPermissionToViewReceptionDesks() ||
            this.hasPermissionToViewClinicRooms() ||
            this.hasPermissionToViewOrderEntities();
    };
    PermissionService.prototype.hasPermissionToShowPatientTabs = function () {
        return this.hasPermissionToIndex(Package) || this.hasPermissionToIndex(Appointments);
    };
    PermissionService.prototype.hasPermissionToChangeAppointmentStatus = function () {
        return this.userService.hasPermission(MarkAsAfterWork, Appointments) ||
            this.userService.hasPermission(MarkAsInVisit, Appointments) ||
            this.userService.hasPermission(MarkAsCancelled, Appointments) ||
            this.userService.hasPermission(MarkAsConfirmed, Appointments) ||
            this.userService.hasPermission(MarkAsFinished, Appointments) ||
            this.userService.hasPermission(MarkAsLate, Appointments) ||
            this.userService.hasPermission(MarkAsPending, Appointments) ||
            this.userService.hasPermission(MarkAsUnReached, Appointments) ||
            this.userService.hasPermission(MarkAsWaiting, Appointments);
    };
    PermissionService.prototype.hasPermissionToMarkAppointmentAs = function (status) {
        var actionByStatus = {
            pending: MarkAsPending,
            un_reached: MarkAsUnReached,
            confirmed: MarkAsConfirmed,
            waiting: MarkAsWaiting,
            in_visit: MarkAsInVisit,
            after_work: MarkAsAfterWork,
            finished: MarkAsFinished,
            cancelled: MarkAsCancelled
        };
        var action = actionByStatus[status];
        if (!action)
            return false;
        return this.userService.hasPermission(action, Appointments);
    };
    PermissionService.prototype.hasPermissionToEditMedicalCenterConfig = function () {
        return this.userService.hasPermission(UpdateConfig, MedicalCenter);
    };
    PermissionService.getInstance = function () {
        if (!PermissionService.permissionService) {
            PermissionService.permissionService = new PermissionService();
        }
        return PermissionService.permissionService;
    };
    return PermissionService;
}(ApiService));
export default PermissionService;
